export enum Regions {
  Australia = 'AUSTRALIA',
  EuropeUnion = 'EUROPE_UNION',
  Global = 'GLOBAL'
}

interface IRegionOption {
  value: Regions;
  label: string;
}

export const AVAILABLE_REGIONS: Array<IRegionOption> = [
  { value: Regions.Global, label: 'Global' },
  { value: Regions.Australia, label: 'Australia' },
  { value: Regions.EuropeUnion, label: 'Europe Union' }
];
export const getAccountRegion = (accountRegion: string | undefined): Regions => {
  return (
    AVAILABLE_REGIONS.find(region => region.value === accountRegion) ?? AVAILABLE_REGIONS[0]
  ).value;
};